import { httpRequest, newHttpRequest } from "../../utils/HttpRequest";
import { IAccountFields, IAccountResult, ICapitalFields, IStatisticsFields } from "./HomeTypes";


class HomeService {
  onlineUser() {
    const apiUrl = "/log/appAccess/onlineUser/";
    return httpRequest.post(apiUrl)
  }

  // 收付款
  todayAccount() {
    const apiUrl = "/account/today";
    return httpRequest
      .get<IAccountResult>(apiUrl);
  }
  monthAccount() {
    const apiUrl = "/account/month";
    return httpRequest
      .get<IAccountResult>(apiUrl);
  }
  yearAccount() {
    const apiUrl = "/account/year";
    return httpRequest
      .get<IAccountResult>(apiUrl);
  }

  // 待审批数
  loadWait(params: { userCode: string }) {
    const apiUrl = "/assets/applyProcess/todo";
    return newHttpRequest.post<any>(apiUrl, params);
  }


}

export const homeService = new HomeService();
